import { useQueryClient } from "@tanstack/react-query";
import { journalsQueries } from "@/entities/journal";
import { $journalApi } from "@/entities/journal/fetch/fetch-client";

export const usePostSignEntry = (sectionOneId?: string, search?: string) => {
  const queryClient = useQueryClient();

  return $journalApi.useMutation(
    "post",
    "/api/v1/journals/section-one/{sectionOneListId}/items/{itemNoVersionId}/sign/done",
    {
      onSuccess: () => {
        if (sectionOneId) {
          queryClient.invalidateQueries({
            queryKey: journalsQueries.getSection1({
              sectionOneId,
              search,
            }).queryKey,
          });
          queryClient.invalidateQueries({
            queryKey:
              journalsQueries.getSectionOneSignersList(sectionOneId).queryKey,
          });
        }
      },
    },
  );
};

